export default __webpack_public_path__ + "static/media/spinning.75c28646.mp3";